import {useLocation, useNavigate} from "react-router-dom";
import {useState} from "react";
import {RouteHelper} from "../../../route/RouteHelper";
import {
    RaikoBaseContainer,
    RaikoBreadcrumb,
    raikoBreadCrumbItemGenerator, RaikoButtonSecondary,
    RaikoFlexFirstChildGrowOne, RaikoGridOneColumn
} from "@moeindal/base-raiko-panel-components";
import Box from "@mui/material/Box";
import TabList from "@mui/lab/TabList";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabPanel from "@mui/lab/TabPanel";
import TourismPlaceDetailBasicInfo from "./TourismPlaceDetailBasicInfo";
import {TourismPlaceCategory} from "./TourismPlaceCategory";

export default function TourismPlaceDetail() {

    const navigate = useNavigate()
    const {state} = useLocation()
    const [pageTitle, setPageTitle] = useState(state && state.title ? state.title : RouteHelper.TourismPlaceDetail.name);

    const [tabSelectedValue, setTabSelectedValue] = useState(tabTypes.detail.id);

    function handleChangeTab(event, newValue) {
        setTabSelectedValue(newValue)
    }


    return (
        <RaikoBaseContainer>
            <RaikoGridOneColumn>
                <RaikoFlexFirstChildGrowOne>
                    <RaikoBreadcrumb
                        breadCrumbItems={[

                            raikoBreadCrumbItemGenerator(
                                RouteHelper.TourismPlaceList.name,
                                RouteHelper.TourismPlaceList.globalUrl
                            ),
                            raikoBreadCrumbItemGenerator(
                                pageTitle,
                                ""
                            ),
                        ]}/>

                    <RaikoButtonSecondary
                        label={"بازگشت"}
                        onClick={_ => {
                            navigate(-1)
                        }}/>
                </RaikoFlexFirstChildGrowOne>

                <TabContext value={tabSelectedValue}>
                    <Box sx={{borderBottom: 1, borderColor: 'divider'}}>
                        <TabList onChange={handleChangeTab} id="default-tab-container" variant="scrollable">
                            <Tab
                                label={tabTypes.detail.title}
                                value={tabTypes.detail.id}/>

                            <Tab
                                label={tabTypes.category.title}
                                value={tabTypes.category.id}/>

                        </TabList>
                    </Box>
                    <TabPanel value={tabTypes.detail.id}>
                        <TourismPlaceDetailBasicInfo/>
                    </TabPanel>
                    <TabPanel value={tabTypes.category.id}>
                        <TourismPlaceCategory/>
                    </TabPanel>
                </TabContext>
            </RaikoGridOneColumn>
        </RaikoBaseContainer>
    )
}


const tabTypes = {
    detail: {
        id: "detail",
        title: "اطلاعات پایه"
    },
    category: {
        id: "category",
        title: "دسته بندی"
    },

}